import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";

import InputBar from "../../components/DriverAssetIssuanceTracking/InputBar";
import DriverAssetIssuanceTrackingData from "../../components/DriverAssetIssuanceTracking/DriverAssetIssuanceTrackingData";
import * as DriverAssetIssuanceTrackingActions from "../../store/actions/DriverAssetIssuanceTracking";
import { Heading } from "../../constants/assets/containers";
import { isMobile, isValNull } from "../../utils";

const DriverAssetIssuanceTracking = (props) => {
  const handleSubmit = (fe_id) => {
    if (!isValNull(fe_id)) {
      props.getDriverAssetIssuanceTracking(fe_id);
    }
  };

  useEffect(() => {
    props.resetState({ state: "driverAssetIssuanceTrackingData" });
  }, []);

  return (
    <DriverAssetIssuanceTrackingContainer>
      <div className="inner-container flex mb-20 items-center justify-between">
        <Heading>Driver Asset Issuance Tracking</Heading>
        <InputBar handleSubmit={handleSubmit} />
      </div>
      <DriverAssetIssuanceTrackingData
        data={props.driverAssetIssuanceTrackingData}
      />
    </DriverAssetIssuanceTrackingContainer>
  );
};

const DriverAssetIssuanceTrackingContainer = styled.section`
  height: calc(100vh - 220px);
  .inner-container {
    flex-direction: ${isMobile() ? "column" : "row"};
    align-items: ${isMobile() ? "flex-start" : "center"};
    .actionBar {
      margin-top: ${isMobile() ? "10px" : "unset"};
    }
  }
`;

const mapStateToProps = (state) => {
  const { DriverAssetIssuanceTracking } = state;
  return {
    driverAssetIssuanceTrackingData:
      DriverAssetIssuanceTracking.driverAssetIssuanceTrackingData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDriverAssetIssuanceTracking: bindActionCreators(
      DriverAssetIssuanceTrackingActions.getDriverAssetIssuanceTracking,
      dispatch
    ),
    resetState: bindActionCreators(
      DriverAssetIssuanceTrackingActions.resetState,
      dispatch
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverAssetIssuanceTracking);
